<script>
import TraderBlock from "./blocks/_TraderBlock.vue";
import LocationBlock from "./blocks/_LocationBlock.vue";

export default {
  name: "DriverMasterGeneralWasteDisposalFormLayout",
  components: {
    TraderBlock,
    LocationBlock,
  },
  props: {
    targetTraderId: {
      type: [String, Number],
      default: () => null,
    },
  },
  computed: {

  },
  watch: {

  },
  data () {
    return {
      selectable: "trader",
    }
  },
  created() {
  },
  methods: {

    /**
     * コールバック
     * 呼び出し元に閉じるボタンを押したことを通知する
     */
    closeCallback () {
      this.$emit("closeCallback")
    },
    /**
     * コールバック
     * 呼び出し元に登録ボタンを押したことを通知する
     */
    registerCallback (id) {
      this.$emit("registerCallback", id)
    },

  },
}
</script>

<template>
  <div>
    <v-tabs
      v-model="selectable"
      background-color="blue lighten-4"
      centered
      icons-and-text
      fixed-tabs
    >
      <v-tabs-slider />
      <v-tab href="#trader">
        事業者
        <v-icon>mdi-bank</v-icon>
      </v-tab>

      <v-tab
        href="#location"
        :disabled="!targetTraderId"
      >
        事業場
        <v-icon>mdi-factory</v-icon>
      </v-tab>

    </v-tabs>
    <v-tabs-items v-model="selectable">
      <v-tab-item value="trader">
        <trader-block
          :target-trader-id="targetTraderId"
          @closeCallback="closeCallback"
          @registerCallback="registerCallback"
        />
      </v-tab-item>

      <v-tab-item value="location">
        <location-block
          :target-trader-id="targetTraderId"
        />
      </v-tab-item>

    </v-tabs-items>
  </div>
</template>

<style scoped lang="scss">

</style>
